<script setup lang="ts">
import type { ChipProps } from './UICarouselChips.props'

defineProps<ChipProps>()

const emit = defineEmits(['selected'])
</script>

<template>
  <button
    v-bind="$attrs"
    class="bg-background-chips text-text-primary text-light-7 gap-xxs flex shrink-0 whitespace-nowrap"
    :class="
      chipSelected ? 'underline-effect-default' : 'underline-effect-appear'
    "
    @click="emit('selected')"
  >
    <div class="text-effect px-sm py-xs before:!bottom-0 after:!bottom-0">
      <UtilsMarkdown
        v-if="chip.label"
        :content="`${chip.label} (${count})`"
        is-preprocessed
        container="p"
      />
    </div>
  </button>
</template>
